<template>
  <div class="legend">
    <span class="legend-item"><span class="legend-color best-price-main" /> {{ $t('PQTOffersView.bestMainPrice') }}</span>
    <span class="legend-item ml-2"><span class="legend-color best-price-alt" /> {{ $t('PQTOffersView.bestAltPrice') }}</span>
    <span class="legend-item ml-2"><span class="legend-color best-total" /> {{ $t('PQTOffersView.bestTotal') }}</span>
  </div>
</template>

<script>
export default {
  name: "PriceLegend"
};
</script>

<style scoped>
/* Legend styles */
.legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.legend-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  border-radius: 3px;
}

.legend-color.best-price-main {
  background-color: #E6F4EA;
  border: 1px solid #28A745;
}

.legend-color.best-price-alt {
  background-color: #E3F2FD;
  border: 1px solid #007BFF;
}

.legend-color.best-total {
  background-color: #FFF3CD;
  border: 1px solid #FFC107;
}

/* Responsive styles */
@media (max-width: 576px) {
  .legend {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 8px;
  }

  .legend-item {
    margin-bottom: 4px;
  }
}
</style>